// Module
var code = "<page-header\n  title=\"'Node Browser'\"\n  breadcrumbs=\"[\n    {\n      label:'swarm',\n      link:'docker.swarm'\n    },\n    {\n      label: $ctrl.node.Hostname,\n      link: 'docker.nodes.node',\n      linkParams: { id: $ctrl.nodeId }\n    },\n    'browse'\n  ]\"\n>\n</page-header>\n\n<host-browser ng-if=\"$ctrl.node\" endpoint-id=\"$ctrl.endpoint.Id\"></host-browser>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/nodes/node-browser/node-browser.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;